// extracted by css-extract-rspack-plugin
export default {"cell":"Cell-module__cell___J4WN8","bottom":"Cell-module__bottom___AesJp"};